export class CodelistContract {

    async queryCodelistData(query = null, options = {}) {
        throw new Error(`${this.constructor.name}: queryCodelistData(query, options) is not implemented.`);
    }

}
